export const SALE_MODEL_B2C = 'b2c';
export const SALE_MODEL_B2B = 'b2b';
export const SALE_MODEL_HYBRID = 'hybrid';
